import React, { useState, useEffect, ChangeEvent } from 'react';
import { Input, Button, Row, Col, Form, FormGroup } from 'reactstrap';
import moment from 'moment';

function BajaForm(props: any) {
  const { data, setData, isLoading, onAccept, onReject } = props;

  const [hasMotivoRechazo, setHasMotivoRechazo] = useState(false);

  useEffect(() => {
    setHasMotivoRechazo(!!data.motivo_rechazo);
  }, [data.id]);

  const accept = () => {
    if (!onAccept) {
      return;
    }

    onAccept();
  };

  const reject = () => {
    if (!onReject) {
      return;
    }

    onReject();
  };

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { target } = event;

    // Guardamos el nuevo valor
    setData({
      ...data,
      [target.name]: target.value,
    });
  };

  return (
    <Form>
      <Row>
        <Col sm={6}>
          <h6 className="heading text-muted mb-4">
            Matriculado
          </h6>
          <Row>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Matricula</label>
                <p>{ data.matricula || '-' }</p>
              </FormGroup>
            </Col>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Delegación</label>
                <p>{ data.delegacion || '-' }</p>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Nombre</label>
                <p>{ data.nombre || '-' }</p>
              </FormGroup>
            </Col>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Apellido</label>
                <p>{ data.apellido || '-' }</p>
              </FormGroup>
            </Col>
          </Row>
          <hr className="my-4" />
          <h6 className="heading text-muted mb-4">
            Solicitud
          </h6>
          <Row>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Desde</label>
                <p>{ moment(data.fecha_desde, 'YYYY-MM-DD').format('DD/MM/YYYY') || '-' }</p>
              </FormGroup>
            </Col>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Hasta</label>
                <p>{ moment(data.fecha_hasta, 'YYYY-MM-DD').format('DD/MM/YYYY') || '-' }</p>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <FormGroup>
                <label className='form-control-label'>Motivo de solicitud</label>
                <p>{ data.motivo_solicitud || '-' }</p>
              </FormGroup>
            </Col>
          </Row>
          <hr className="my-4" />
          <h6 className="heading text-muted mb-4">
            Rechazo
          </h6>
          <Row>
            <Col sm={12}>
              <FormGroup>
                <label className='form-control-label'>Motivo de rechazo</label>
                {
                  hasMotivoRechazo
                    ?
                      <p>{ data.motivo_rechazo }</p>
                    :
                      <Input
                        id="motivo_rechazo"
                        name="motivo_rechazo"
                        type="textarea"
                        value={data.motivo_rechazo ?? ''}
                        onChange={handleInputChange}
                        disabled={isLoading}
                        required
                      />
                }
              </FormGroup>
            </Col>
          </Row>
        </Col>
      </Row>
      {
        onAccept || onReject
          ? <Row>
              <hr className="my-4" />
              <Col className="text-center">
                <Button color="danger" onClick={ reject } disabled={ isLoading }>Rechazar</Button>
                <Button color="success" onClick={ accept } disabled={ isLoading }>Aceptar</Button>
              </Col>
            </Row>
          : null
      }
    </Form>
  );
}

export default BajaForm;
